import { buildSkillStep } from "@/core/skillForms/builder";

export const settlementOfferSkillStep1 = buildSkillStep({
  title: "Detalhes do caso",
  description:
    "Elaborar propostas de acordo com o Assistente Lexter é muito fácil. Preencha os detalhes do caso abaixo.",
  fields: [
    {
      name: "area",
      type: "string",
      options: [
        { value: "Cível" },
        { value: "Trabalhista" },
        { value: "Previdenciário" },
        { value: "Tributário" },
        { value: "Criminal" },
        {
          value: "Outros",
        },
      ],
      ui: {
        label: "Área jurídica",
        placeholder: "Selecione a área jurídica",
      },
    },
    {
      name: "custom_area",
      type: "string",
      ui: {
        label: "Digite a área jurídica:",
        placeholder: "Exemplos: Direito Ambiental, Direito Administrativo...",
        widget: "textarea",
      },
      condition: {
        field: "area",
        value: "Outros",
      },
    },
    {
      name: "client",
      type: "string",
      ui: {
        label: "Qual é o nome do cliente?",
        placeholder: "Exemplo: João da Silva.\nSe tiver mais de um nome, separe com vírgulas.",
      },
    },
  ],
});
